<template>
  <div class="foot-c-container">
    <span class="font-ct-title">联系我们 & 办公信息</span>
    <div class="foot-ct-item" @click="onPhoneClick()">
       <div class="foot-ct-item-img_bg">
         <div class="foot-ct-item-img_second_bg">
            <img class="foot-ct-item-img" src="@/assets/img_phone.png">
         </div>
       </div>
      <div class="foot-ct-item-text-div">
          <span class="foot-ct-item-text-1">业务经理</span>
          <span class="foot-ct-item-text-2 margin-top-5">13167540356</span>
      </div>
    </div>
    <div class="foot-ct-item" @click="onQRCodeClick()">
       <div class="foot-ct-item-img_bg">
         <div class="foot-ct-item-img_second_bg">
            <img class="foot-ct-item-img" src="@/assets/img_time.png">
         </div>
       </div>
      <div class="foot-ct-item-text-div">
          <span class="foot-ct-item-text-1">办公时间</span>
          <span class="foot-ct-item-text-2 margin-top-5">8:30 - 18:30，周一到周五</span>
      </div>
    </div>
    <div class="foot-ct-item" @click="onQRCodeClick()">
       <div class="foot-ct-item-img_bg">
         <div class="foot-ct-item-img_second_bg">
            <img class="foot-ct-item-img" src="@/assets/img_location.png">
         </div>
       </div>
      <div class="foot-ct-item-text-div">
          <span class="foot-ct-item-text-1">公司地址</span>
          <span class="foot-ct-item-text-2 margin-top-5">河北省廊坊三河市燕郊开发区</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {isShowQrCodeDialog} from "@/views/data/CommonData";

const onQRCodeClick = () => {
  isShowQrCodeDialog.value = true
}
const onPhoneClick = () => {
  window.location.href = 'tel:13167540356';
}
</script>

<style scoped>
.foot-c-container{
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 20px;
}

.font-ct-title{
  color: #b1b1b1;
  font-size: 13px;
}

.foot-ct-item{
  display: flex;
  align-items: center;
  margin-top: 15px;
}

.foot-ct-item-img_bg {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  border: 1px solid #4e5c71;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #383a5b;
}

.foot-ct-item-img_second_bg {
  width: 42px;
  height: 42px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fcfc;
}
.foot-ct-item-img{
  width: 20px;
  height: 20px;
}
.foot-ct-item-text-div{
  height: 50px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 15px;
}
.foot-ct-item-text-1{
  color: #b1b1b1;
  font-size: 13px;
}
.foot-ct-item-text-2{
  color: #f9fcfc;
  font-weight: bold;
  font-size: 15px;
}
</style>
